import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import DeferInviteSessionProvider from 'modules/Notifications/DeferInviteSessionProvider';
import useMeetingSpaceInviteNotifications from 'modules/Notifications/useMeetingSpaceInviteNotifications';
import useMessengerRoomInviteNotifications from 'modules/Notifications/useMessengerRoomInviteNotifications';
import useWorkspaceInviteNotifications from 'modules/Notifications/useWorkspaceInviteNotifications';

// Root-mounted so invite notifications are observed regardless of the current route. The previous
// mount point (NotificationsButton) unmounts on `/rooms/*`, dropping in-call invites (#8150). Each
// hook internally defers UI off the app shell and flushes the Matrix invite queue on shell return.
const InviteNotificationsFeeder = () => {
  const { matrixClient } = useMatrixContext({ requireDefinedMatrixClient: false });
  if (!matrixClient) return null;
  return (
    <DeferInviteSessionProvider>
      <MountedInviteNotificationsFeeder />
    </DeferInviteSessionProvider>
  );
};

const MountedInviteNotificationsFeeder = () => {
  useWorkspaceInviteNotifications();
  useMessengerRoomInviteNotifications();
  useMeetingSpaceInviteNotifications();
  return null;
};

export default InviteNotificationsFeeder;
